import React from "react";
import "../CSS/Slide.css";
import Phone from "../Images/Phone_Mockup.png";
import Arrow from "../Images/arrow.svg";
import { Images } from "./Images";


const Slide = () => {
    return (

        <>
            <div className="Projects">
                <h1 className="recent">MY RECENT PROJECT</h1>
                <div className="Card">
                    <div className="image"><img src={Phone} alt="Mockup"></img></div>
                    <div className="content">
                        <div className="Heading">
                        <h1 style={{color:"#02B79A"}}>Blood Donor</h1>
                        
                        <h1>Mobile Application</h1>
                        </div>
                        {/* <div className="border"></div> */}
                        <div className="border">
                            <img src={Images.Slideline}/>
                        </div>
                        <p className="paragraph">
                            Blood Donor is an mobile application that makes it easier for people to<br/>
                            find in an emergency situation & track their blood donors locations to<br/>
                            make it easier than ever and also easy to communicate with the people<br/>
                            using our chat feature.
                        </p>
                        <div className="Casestudy">
                            <a href="https://dribbble.com/shots/20926225-Blood-Donor-Mobile-Application" style={{textDecoration:"None"}}><h1 className="view">View Case Study</h1></a>
                            <a href="https://dribbble.com/shots/20926225-Blood-Donor-Mobile-Application"><img src={Arrow} className="arrow" alt="arrow" /></a>
                        </div>
                    </div>
                    
                </div>

            </div>
        </>

    )
}

export default Slide;